/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { service } from '@ember/service';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { tagName } from '@ember-decorators/component';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

@tagName('')
export default class GoalCard extends Component {
  @service
  session;

  @service
  permissions;

  @service
  router;

  @service
  features;

  GoalState = GoalState;
  @tracked detailed = false;
  @tracked
  selectedGoal = null;
  @tracked
  showExemplar = false;
  isGradable = false;

  // refreshStates is passed in by the parent. It must stay a plain method:
  // classic components set arguments as properties, and an @action is a
  // getter-only accessor, so passing @refreshStates would throw.
  refreshStates() {}

  onRouteTransition() {}

  @computed('detailed', 'state.awarded', 'class')
  get cardClasses() {
    let classes = ['goal-card'];

    if (this.detailed) {
      classes.push('goal-card-detailed');
    }

    switch (this.get('state.awarded')) {
      case GoalState.DEVELOPING:
        classes.push('goal-developing');
        break;
      case GoalState.SECURE:
        classes.push('goal-secure');
        break;
    }

    if (!isEmpty(this.class)) {
      classes.push(this.class);
    }

    return classes.join(' ');
  }

  // Current user can delete a goal if they're a teacher or admin
  @computed(
    'person.homeroom.currentStaff.@each.personId',
    'session.{scopes.[],person.id}',
    'goal.authorId.id',
  )
  get canDelete() {
    return (
      findBy(
        this.person.homeroom.currentStaff,
        'personId',
        this.session.person.id,
      ) ||
      this.goal.authorId.get('id') === this.session.person.id ||
      this.permissions.meet(Scopes.TENANT_ADMIN)
    );
  }

  @action
  noOp() {}

  @action
  goToRoute(route, params) {
    this.onRouteTransition();
    this.router.transitionTo(route, ...params);
  }

  @action
  onClose() {
    this.showExemplar = false;
  }

  @action
  openExemplar(selectedGoal) {
    this.selectedGoal = selectedGoal;
    this.showExemplar = true;
  }
}
